/** The published 8080.AI Snap & Share extension, which also runs loops (2.6.9 and later). */
export const CHROME_WEB_STORE_EXTENSION_URL = 'https://chromewebstore.google.com/detail/8080ai-snap-share/iaoojciflkdjbjkdhchgddpoknkianej';
